let questiones = document.querySelectorAll(".questiones");

// ✅ Open the first FAQ by default
if (questiones.length > 0) {
  questiones[0].classList.add("active");
  const firstAnswer = questiones[0].nextElementSibling;
  firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
}

questiones.forEach(question => {
  question.addEventListener("click", event => {
    const active = document.querySelector(".questiones.active");
    if (active && active !== question) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
    }
    question.classList.toggle("active");
    const answer = question.nextElementSibling;
    if (question.classList.contains("active")) {
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = 0;
    }
  });
});

 

 const tabsespd = document.querySelectorAll('.tabs__btnpd');
 const tabsContent = document.querySelectorAll('.tabs__bodypd');

  if (tabsContent.length > 0 || tabs.length > 0) {

    function hideTabContent() {
      tabsContent.forEach(item => {
        item.classList.remove('active');
      });

      tabsespd.forEach(item => {
        item.classList.remove('active');
      });
    }

    function showTabContent(i = 0) {
      tabsContent[i].classList.add('active');
      tabsespd[i].classList.add('active');
    }

    hideTabContent();
    showTabContent();

    tabsespd.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        hideTabContent();
        showTabContent(index);
      });
    });
  }

